import { useCallback, useMemo } from 'react';
import { ProfessionalProfessions } from '~/constants';
import { getShouldOfficeShowEfda } from '~/growthbook';
import { ProfessionTypeEnum } from '~/models';
import { getAllProfessionTypeOptions } from '~/utils/DentistUtils';

const EMPTY_EXCLUDES: ProfessionTypeEnum[] = [];

interface IUseProfessionOptionsPayload {
  isShowAllOpt?: boolean;
  excludes?: ProfessionTypeEnum[];
}

export const useProfessionOptions = ({
  isShowAllOpt = false,
  excludes = EMPTY_EXCLUDES,
}: IUseProfessionOptionsPayload = {}) => {
  const options = useMemo(() => {
    const isShowEFDA = getShouldOfficeShowEfda();

    const raw = [
      ...(isShowAllOpt
        ? [
            {
              label: 'All Profession Type',
              value: 'all',
            },
          ]
        : []),
      ...getAllProfessionTypeOptions(ProfessionalProfessions, {
        showEfda: isShowEFDA,
      }).map((it) => ({
        label: it.name,
        value: it.code,
      })),
    ];

    return raw.filter((opt) => !excludes.includes(opt.value as ProfessionTypeEnum));
  }, [isShowAllOpt, excludes]);

  const findByCode = useCallback(
    (code: string) => options.find((opt) => opt.value === code),
    [options],
  );

  return { options, findByCode };
};
